import {
    INVENTORY_GET_REQUEST,
    INVENTORY_RESET_ON_PPID_CHANGE,
} from '../actionTypes/InventoryActionTypes';

export const getInventoryAction = (payload) => ({
    type: INVENTORY_GET_REQUEST,
    payload,
});

export const resetInventoryAction = (sourceMiniPDP = false) => ({
    type: INVENTORY_RESET_ON_PPID_CHANGE,
    sourceMiniPDP,
});
